module.exports = __webpack_public_path__ + "img/nutechlogo.d9c1c83b.png";